import React from 'react';

/** Copied from `frontend/public/` to the site root by Vite (`/signature-song.mp3`). */
const SIGNATURE_SONG_SRC = '/signature-song.mp3';

export interface SignatureSongLyricsProps {
  listenCaption: string;
  audioUnsupportedFallback: string;
}

/**
 * Shared audio player and lyrics. Song text stays in the original English regardless of UI language.
 */
export const SignatureSongLyrics: React.FC<SignatureSongLyricsProps> = ({
  listenCaption,
  audioUnsupportedFallback,
}) => (
  <>
    <figure className="signature-song-player">
      <figcaption className="signature-song-player-caption">{listenCaption}</figcaption>
      <audio controls preload="metadata" src={SIGNATURE_SONG_SRC}>
        {audioUnsupportedFallback}
      </audio>
    </figure>

    <hr />

    <div className="song-lyrics">
      <p><strong>[Verse 1]</strong><br />
      In the static hum of a midnight glow<br />
      Ding–ding–dong–ding–ding – it flows.<br />
      A whisper buried where no one goes,<br />
      Do you hear it? Do you know?</p>

      <p><strong>[Pre-Chorus]</strong><br />
      Fingers tapping like a ghost unseen,<br />
      A language cracked in a coded dream.<br />
      Ding–ding–dong–ding–ding repeats,<br />
      The pulse of secrets, hidden beats.</p>

      <p><strong>[Chorus]</strong><br />
      I think it's you,<br />
      I think it's you,<br />
      In the shadows where the secrets grew.<br />
      I think it's you,<br />
      The signal's true—<br />
      Meet me where the whispers flew.</p>

      <p><strong>[Verse 2]</strong><br />
      A missed connection on a crooked wire,<br />
      A spark of clues, a quiet fire.<br />
      Ding–Ding–dong, it won't expire,<br />
      Crime Club's calling, pull me higher.</p>

      <p><strong>[Pre-Chorus]</strong><br />
      Behind the veil where the echoes live,<br />
      This is the password I'll always give.<br />
      Ding–ding–dong–ding–ding, in time,<br />
      A key, a lock, a secret rhyme.</p>

      <p><strong>[Chorus]</strong><br />
      I think it's you,<br />
      I think it's you,<br />
      In the static where the truth breaks through.<br />
      I think it's you,<br />
      The trace I knew,<br />
      Follow the signal—rendezvous.</p>

      <p><strong>[Bridge]</strong><br />
      I saw you in the static haze,<br />
      A shadow moving through secret maze.<br />
      Top secret signals, anonym,<br />
      A hidden truth beneath the hymn.<br />
      Ding–ding–dong–ding–ding aligned,<br />
      The echo whispers: you're the sign.</p>

      <p><strong>[Final Chorus]</strong><br />
      I think it's you,<br />
      I think it's you,<br />
      In the silence where the dark breaks through.<br />
      I think it's you,<br />
      The code, the clue—<br />
      Top secret rendezvous, anonym, with you.<br />
      Ding–ding–dong–ding–ding, it's true—<br />
      The signal's beating, and it points to you.</p>
    </div>
  </>
);
